import React from "react";
import { optionsCivilite, optionsIndice } from "../../../utils/selectOptions";
import Select from "../../UI/Select";

const FormMandantMorale = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
  handleChangeMandantConfirm,
}) => {
  return (
    <>
      <div className="mt-4">
        <div className="background--warning p-3">
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandantRaisSos" className="form-label">
                Dénomination et raison sociale&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                id="MandantRaisSos"
                name="MandantRaisSos"
                maxLength={50}
                value={formData.MandantRaisSos || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantFormeJuridique" className="form-label">
                Type de société&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                id="MandantFormeJuridique"
                name="MandantFormeJuridique"
                maxLength={20}
                value={formData.MandantFormeJuridique || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                placeholder="SA, SARL, SCI..."
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 position-relative">
              <label htmlFor="MandantSiret" className="form-label">
                SIRET&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                pattern="^\d{14}$"
                id="MandantSiret"
                className="form-control page-1-required mandant-group inputReg getLabel"
                name="MandantSiret"
                maxLength={14}
                value={formData.MandantSiret || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                placeholder="N° (14 chiffres)"
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro valide
              </div>
            </div>
          </div>
        </div>
        <p className="mt-4 mb-4 fw-bold">
          Adresse du siège social à la date de la demande :
        </p>
        <div className="background--warning p-3">
          <div className="row pb-4">
            <div className="col-12 col-md-4 position-relative">
              <label htmlFor="MandantAdrNum" className="form-label">
                Numéro de voie <span className="text-danger">(facultatif)</span>
                &nbsp;:
              </label>
              <input
                type="text"
                pattern="[0-9]+"
                className="form-control mandant-group getLabel"
                id="MandantAdrNum"
                name="MandantAdrNum"
                maxLength={5}
                value={formData.MandantAdrNum || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro valide
              </div>
            </div>
            <div className="col-12 col-md-3 mt-3 mt-md-0">
              <Select
                selectClassName={"page-1-required mandant-group"}
                name="MandantAdrRepetition"
                value={formData.MandantAdrRepetition}
                handleChange={handleChange}
                inputFocus={inputFocus}
                options={optionsIndice}
                label="Indice de répétition :"
              />
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrRue" className="form-label">
                Type et nom de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                name="MandantAdrRue"
                id="MandantAdrRue"
                maxLength={50}
                value={formData.MandantAdrRue || ""}
                onInput={inputFocus}
                onChange={handleChange}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrComp" className="form-label">
                Complément d'adresse{" "}
                <span className="text-danger">(facultatif)</span>&nbsp;:&nbsp;
              </label>
              <input
                type="text"
                className="form-control mandant-group getLabel"
                name="MandantAdrComp"
                id="MandantAdrComp"
                maxLength={50}
                value={formData.MandantAdrComp || ""}
                onInput={inputFocus}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandantAdrCP" className="form-label">
                Code postal&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group inputReg getLabel"
                name="MandantAdrCP"
                id="MandantAdrCP"
                value={formData.MandantAdrCP || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un code postal valide
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrVille" className="form-label">
                Commune&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                name="MandantAdrVille"
                id="MandantAdrVille"
                maxLength={40}
                value={formData.MandantAdrVille || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 position-relative">
              <label htmlFor="MandantAdrPays" className="form-label">
                Pays&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                name="MandantAdrPays"
                id="MandantAdrPays"
                maxLength={20}
                value={formData.MandantAdrPays || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
        </div>
        <p className="mt-4 mb-4 fw-bold">Représentant légal&nbsp;:</p>
        <div className="background--warning p-3">
          <div className="row pb-4">
            <div className="col-12 col-md-2 mt-3 mt-md-0">
              <Select
                selectClassName={"page-1-required mandant-group"}
                name="MandantCivil"
                value={formData.MandantCivil}
                handleChange={handleChange}
                inputFocus={inputFocus}
                options={optionsCivilite}
                label="Civilité :"
              />
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantPrenom" className="form-label">
                Prénom&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                name="MandantPrenom"
                id="MandantPrenom"
                maxLength={30}
                value={formData.MandantPrenom || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantNom" className="form-label">
                Nom de famille&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                name="MandantNom"
                id="MandantNom"
                maxLength={30}
                value={formData.MandantNom || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 mt-3 mt-md-0">
              <label htmlFor="MandantNomNaissance" className="form-label">
                Nom de jeune fille{" "}
                <span className="text-danger">(le cas échéant)</span>&nbsp;:
              </label>
              <input
                type="text"
                className="form-control getLabel"
                name="MandantNomNaissance"
                id="MandantNomNaissance"
                maxLength={30}
                value={formData.MandantNomNaissance || ""}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantQualDemandeur" className="form-label">
                Qualité&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandant-group getLabel"
                name="MandantQualDemandeur"
                id="MandantQualDemandeur"
                maxLength={30}
                value={formData.MandantQualDemandeur || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandantEmail" className="form-label">
                Votre adresse e-mail&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control page-1-required mandant-group inputReg getLabel"
                name="MandantEmail"
                id="MandantEmail"
                maxLength={40}
                value={formData.MandantEmail || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                placeholder="ex: email@example.com"
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer une adresse email valide
              </div>
            </div>
            <div className="col-12 col-md-6 pt-3 pt-md-0 position-relative">
              <label htmlFor="MandantEmailConfirme" className="form-label">
                Confirmer Votre adresse e-mail&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control page-1-required confirmMandantEmail_M mandant-group getLabel"
                name="MandantEmailConfirme"
                id="MandantEmailConfirme"
                maxLength={40}
                value={formData.MandantEmailConfirme || ""}
                onChange={handleChangeMandantConfirm}
                onInput={inputFocus}
                onPaste={(e) => e.preventDefault()}
                onBlur={handleTrimValue}
                required
                placeholder="ex: email@example.com"
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer une adresse email identique
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandantTel" className="form-label">
                Votre numéro de téléphone portable&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                pattern="[0-9+]+"
                className="form-control page-1-required mandant-group inputReg getLabel"
                name="MandantTel"
                id="MandantTel"
                maxLength={15}
                value={formData.MandantTel || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
                placeholder="ex: 0601020304"
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone mobile valide
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantTelFixe" className="form-label">
                Votre numéro de téléphone fixe{" "}
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="tel"
                pattern="[0-9]+"
                className="form-control mandant-group page-1-required inputReg getLabel"
                name="MandantTelFixe"
                id="MandantTelFixe"
                maxLength={15}
                value={formData.MandantTelFixe || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                placeholder="ex: 0235010203"
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone valide
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="alert alert-info mt-4">
        <i className="fas fa-info-circle"></i>&nbsp;
        <strong>Pour information :</strong>&nbsp;En cas d'indivision ou de SCI,
        veuillez renseigner le nom de tous les propriétaires figurant sur le
        titre de propriété.
      </div>
    </>
  );
};

export default FormMandantMorale;
